import * as React from "react";
import { styled } from "@mui/system";
import { TextHighlight } from "fe-common/commonTypes/errors";
import { FormInputProps } from "./formInput";
import { forwardRef } from "react";

//region [[ Styles ]]

const FormInputHighlightView = styled("div")({
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  alignItems: "start",
  padding: "16.5px 14px",
  "& .container": {
    whiteSpace: "pre-wrap",
    color: "#00000000",
    lineHeight: 1.44,
    height: "100%",
    overflow: "auto",
  },
  "& .highlight": {
    background: "rgb(253, 236, 234)",
    padding: "0 2px",
    margin: "0 -2px",
    borderRadius: 3,
    borderBottom: "2px solid #f44336",
    lineHeight: 1,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface FormInputHighlightProps extends FormInputProps {
  highlights: TextHighlight[];
}

//endregion [[ Props ]]

//region [[ Functions ]]
const highlightWords = (text: string, ranges: TextHighlight[]) => {
  if (!ranges?.length) return text;
  let offset = 0;
  const spans = ranges.reduce((sliced, range, currentIndex) => {
    const resliced = [
      ...sliced,
      text.slice(offset, range.BeginOffset),
      <span className={"highlight"} key={"hl" + currentIndex}>
        {text.slice(range.BeginOffset, range.EndOffset)}
      </span>,
    ];
    offset = range.EndOffset;
    return resliced;
  }, []);
  return [...spans, text.slice(offset, text.length)];
};
//endregion [[ Functions ]]

export const FormInputHighlight = forwardRef(function(
  { ...props }: FormInputHighlightProps,
  ref,
) {
  return (
    <FormInputHighlightView
      id={props.id + "Highlighter"}
      className={`highlighter MuiInputBase-root ${
        props.disabled ? " Mui-disabled" : ""
      }`}
      contentEditable={!props.disabled}
      suppressContentEditableWarning
    >
      <div className={"container"} ref={ref as any}>
        {props.value && highlightWords(props.value, props.highlights)}
      </div>
    </FormInputHighlightView>
  );
});
